var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-layers',{class:_vm.size},[_c('font-awesome-icon',{attrs:{"icon":['far', 'traffic-light'],"size":"4x"}}),_c('font-awesome-icon',{attrs:{"icon":"circle","color":_vm.color,"transform":_vm.transform}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }